/**
 * Título + subtítulo acima do card de onboarding.
 */
import type { ReactNode } from 'react';

type Props = {
  title: string;
  children: ReactNode;
};

export default function OnboardingHero({ title, children }: Props) {
  return (
    <header className="mb-s5 text-center sm:mb-s6">
      <h1
        id="onboarding-step-title"
        className="text-balance text-xl font-semibold tracking-tight text-default sm:text-2xl lg:text-3xl"
      >
        {title}
      </h1>
      <div className="mx-auto mt-s2 max-w-md text-pretty text-sm text-muted sm:text-base">
        {children}
      </div>
    </header>
  );
}
